module.exports = __webpack_public_path__ + "02b5e074aab325aacc157dc92e2fb87d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/northwestern_university_2_2023_chart.png
// module id = 1706
// module chunks = 0